import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "./app-token.service";
import { HttpHandlerService } from "./http-handler.service";

@Injectable({
    providedIn: 'root'
})
export class CustomerService {

    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getAllEndPoint = 'customers';
    _getAllListEndPoint = 'customers/list';
    _addEndPoint = 'customers';
    _updateEndPoint = 'customers';
    _updateStatus = 'customers/status';
    _getByIdEndPoint = 'customers/';
    _deleteEndPoint = 'customers/';
    _getAllContractEndPoint = 'customers/contract';
    _volumetric = 'customers/volumetric'
    
    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public UpdateContract(contractData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllContractEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            contractData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddContract(contractData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllContractEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            contractData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public AddCustomerVolumetric(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._volumetric}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public getVolumetricDataForAwb(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._volumetric}/awb`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateCustomerVolumetric(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._volumetric}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public DeleteContract(id:any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllContractEndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    
    public GetAll(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}?isactive=${params?.isactive}&sc=${params?.scid}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getAllListEndPoint}?sc=${params.scid}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetById(customerId: any, params? : any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getByIdEndPoint}${customerId}?type=${params?.type}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetVolumetricDetailByCustId(customerId: any, params? : any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._volumetric}/${customerId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetVolumetricDetailById(id: any, params? : any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._volumetric}/info/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._addEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public Update(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._updateEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public UpdateStatus(status: boolean, productId: number): Observable<boolean> {
        const full_api_url = `${this._apiUrl}${this._updateStatus}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            { status, productId }
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Delete(customerId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._deleteEndPoint}${customerId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetCustomerPickupDetails(customerid: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/pickupdetails/${customerid}`;
        const request_option = this._httpHandler.prepareRequest(
            'GET', 
            full_api_url, 
            {}
        );
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    
    public getContractDetailbyCustId(id?:any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllContractEndPoint}/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public getContractDetailById(id:any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllContractEndPoint}/info/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }


    public UploadContract(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/contract/upload`;
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    public UploadDocument(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/contract/uploaddoc`;
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllCurrency(): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/currency`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public DeleteVolumetric(id:any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._volumetric}/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public checkKyc(obj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/kyc/check`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            obj
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
}